export default __webpack_public_path__ + "static/media/get-involved-mobile-hero.5bf6795e.png";